import { ReactNode, createContext } from 'react';
import { ToastProps } from '#shared/components/Toast/Toast';

export type ToastOptions = Pick<ToastProps, 'subTitle' | 'renderRight' | 'closeButton'>;
export type ToastMethod = (title: ReactNode, options?: ToastOptions) => void;

export type ToastService = {
  success: ToastMethod;
  neutral: ToastMethod;
  error: ToastMethod;
  close: () => void;
};

export const ToastContext = createContext<ToastService | null>(null);
